import React, { useState, useEffect } from 'react';
import { storage } from '../firebase';
import { ref, listAll, getDownloadURL, getMetadata } from 'firebase/storage';
import './Gallery.css';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Check if images are already stored in local storage
        const cachedImages = localStorage.getItem('galleryImages');
        const cachedTotalSize = localStorage.getItem('galleryImagesSize');

        // Create a reference to the 'images' directory
        const storageRef = ref(storage, 'Gallery');
        // List all items (files) in the 'images' directory
        const imageRefs = await listAll(storageRef);

        // Get the total size of all images in Firebase
        const totalSize = await Promise.all(
          imageRefs.items.map(async (itemRef) => {
            const metadata = await getMetadata(itemRef);
            return metadata.size;
          })
        ).then(sizes => sizes.reduce((a, b) => a + b, 0)); // Sum of all image sizes

        // If cached size matches total size, load from localStorage
        if (cachedImages && cachedTotalSize && parseInt(cachedTotalSize) === totalSize) {
          setImages(JSON.parse(cachedImages));
          setLoading(false);
          console.log('')
          return;
        }

        // Get URLs for all image files
        const urls = await Promise.all(
          imageRefs.items.map(async (itemRef) => {
            try {
              const url = await getDownloadURL(itemRef);
              return url;
            } catch (error) {
              console.error('Error getting download URL for', itemRef.name, error);
              return null;
            }
          })
        );

        // Filter out null values
        const validUrls = urls.filter(url => url !== null);

        // Store images in local storage
        localStorage.setItem('galleryImages', JSON.stringify(validUrls));
        localStorage.setItem('galleryImagesSize', JSON.stringify(totalSize));

        setImages(validUrls);
      } catch (error) {
        console.error('Error fetching images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  // Function to handle image click (expands image to full screen)
  const handleImageClick = (index) => {
    setSelectedIndex(index);
  };

  // Function to close the expanded view
  const handleClose = () => {
    setSelectedIndex(null);
  };

  // Function to handle navigation (left and right)
  const handlePrev = () => {
    setSelectedIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="gallery-container">
      <h1>GALLERY</h1>
      {loading ? (
        <p>Loading images...</p>
      ) : (
        <div className="gallery-grid">
          {images.length > 0 ? (
            images.map((url, index) => (
              <div key={index} className="gallery-item" onClick={() => handleImageClick(index)}>
                <img src={url} alt={`Gallery Item ${index + 1}`} />
              </div>
            ))
          ) : (
            <p>No images found.</p>
          )}
        </div>
      )}

      {/* Modal for expanded image view */}
      {selectedIndex !== null && (
        <div className="expanded-view">
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
          <button className="prev-button" onClick={handlePrev}>
            &#10094;
          </button>
          <img
            className="expanded-image"
            src={images[selectedIndex]}
            alt={`Expanded Gallery Item ${selectedIndex + 1}`}
          />
          <button className="next-button" onClick={handleNext}>
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
